import React from "react";

import { CustomPromptRefProps } from "@/components/molecules/CustomPrompt/CustomPromptContainer";

export const promptRef = React.createRef<CustomPromptRefProps>();
